import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const isNeedToFetchListSelector: Selector<ReduxState, boolean> = state => {
  const { currentPage, pages } = state.processingCosts.pagination
  return !pages[currentPage]
}

export default isNeedToFetchListSelector
